import { AsyncPipe, NgClass, NgIf, NgStyle, NgTemplateOutlet } from "@angular/common";
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { RouterLink } from "@angular/router";
import { environment } from "@estatex/environments";
import { HeaderVersion, NavigationService, UserService } from "@estatex/services";
import { combineLatest, Subject, takeUntil } from "rxjs";

@Component({
    selector: "app-header",
    standalone: true,
    imports: [RouterLink, NgTemplateOutlet, NgClass, NgStyle, NgIf, AsyncPipe],
    templateUrl: "./header.component.html",
    styleUrl: "./header.component.css",
})
export class HeaderComponent implements OnInit, OnDestroy {
    isTransparent = false;
    isAdminPanel = false;
    isLandingPage = true;
    isLoggedIn = false;
    isDataLoaded = false;

    hideHamburgerMenu = false;
    environment = environment.ENVIRONMENT;

    private readonly unsubscribe$ = new Subject<void>();

    constructor(
        private readonly navigationService: NavigationService,
        readonly userService: UserService,
        private readonly cdr: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        combineLatest([this.navigationService.headerVersion$, this.navigationService.adminPanel$, this.userService.loggedIn$])
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(([ver, isAdminPanel, loggedIn]) => {
                this.isTransparent = HeaderVersion.TRANSPARENT === ver;
                this.isAdminPanel = isAdminPanel;
                this.isLandingPage = !this.isAdminPanel;
                this.isLoggedIn = loggedIn;
            });
    }

    /**
     * Logs out of the estatex-admin application
     */
    logout(): void {
        this.userService.logout();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
